import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import AdminApi from '../../api/admin-api/admin-api'
import { toast } from 'react-toastify'

class AdminTechTools extends Component {
  constructor(props) {
    super(props)
    this.state = {
      techToolsList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      viewdata: '',
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Title',
            field: 'title',
            sort: 'asc',
            width: 350,
          },
          {
            label: 'Edit',
            field: 'edit',
            sort: 'disabled',
            width: 100,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'disabled',
            width: 100,
          },
        ],
        rows: [],
      },
    } // state end
  }

  componentDidMount() {
    this.fetchTechToolsData()
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeleteTechTools = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { techToolsList } = this.state
    if (techToolsList && techToolsList.length) {
      let rows = techToolsList.map(row => {
        const { tool_title, id } = row
        const self = this

        function editTechTools() {
          self.props.history.push(`/edit-techtools/${id}/edit`)
        }

        function deleteTechTools() {
          self.confirm_DeleteTechTools({ viewdata: row })
        }

        const editClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={editTechTools}>
              <MDBIcon icon='edit' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deleteTechTools}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        return {
          title: tool_title,
          edit: editClick,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  //Fetch data
  fetchTechToolsData = async () => {
    try {
      this.setState({ loading: true })

      const result = await AdminApi.getTechToolsList()
      const techToolsList = result?.data?.data || []

      this.setState({ techToolsList }, () => {
        this.setRows()
      })
    } catch (error) {
      toast.error(error.message || 'Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  //Delete data
  _DeleteTechTools = async id => {
    this.setState({ deleting: true })
    const data = { tool_id: id }

    AdminApi.deleteTechTools(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('TechTools successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchTechToolsData()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { data, confirmModal, loading } = this.state

    const createNew = () => {
      this.props.history.push('/edit-techtools')
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Tech Tools
                <div className='d-inline-block'>
                  <MDBBtn
                    type='button'
                    color='default'
                    tag='a'
                    floating
                    gradient='blue'
                    title={'Add Tech Tools'}
                    onClick={createNew}
                  >
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              <hr />
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <div className='content-wrapper'>
                  <MDB4Datatable data={data} striped bordered small className='text-capitalize' />
                </div>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete TechTools</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this TechTools?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeleteTechTools(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminTechTools
